import React, { useState } from "react";
import styles from "./SettingsHistoricalAchievementsPage.module.css";
import { useSettingsHistoricalAchievementsViewModel } from "@/features/settings/viewModal/useSettingsHistoricalAchievementsViewModel";
import heroBannerImg from "@/assets/images/achievements-hero-banner.jpg";

// Custom Crisp SVGs matching the design
const MoneyBagIcon = () => (
  <svg
    className={styles.summaryIcon}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14 6C15.6569 6 17 4.65685 17 3H11C11 4.65685 12.3431 6 14 6Z" fill="#16a34a" />
    <path
      d="M8.5 7.5C6.5 8 5 11 5 14C5 19 8.5 24 14 24C19.5 24 23 19 23 14C23 11 21.5 8 19.5 7.5L17.5 6.5C16.8 6.2 16 6 14 6C12 6 11.2 6.2 10.5 6.5L8.5 7.5Z"
      fill="#22c55e"
    />
    <path
      d="M14 10.5V18.5M11.5 12.5C11.5 11.5 12.5 11 14 11C15.5 11 16.5 11.5 16.5 12.5C16.5 14 11.5 14 11.5 15.5C11.5 16.5 12.5 17.5 14 17.5C15.5 17.5 16.5 17 16.5 16"
      stroke="#ffffff"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DocumentSummaryIcon = () => (
  <svg
    className={styles.summaryIcon}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="6"
      y="4"
      width="16"
      height="20"
      rx="3"
      fill="#e0f2fe"
      stroke="#0284c7"
      strokeWidth="1.5"
    />
    <path d="M10 9H18" stroke="#0284c7" strokeWidth="2" strokeLinecap="round" />
    <path d="M10 13H18" stroke="#0284c7" strokeWidth="2" strokeLinecap="round" />
    <path d="M10 17H15" stroke="#0284c7" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const MedalIcon = () => (
  <svg
    className={styles.medalIcon}
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17 25L14 38L22 34L30 38L27 25" fill="#b45309" />
    <path d="M17 25L13 39L20 35" fill="#92400e" />
    <path d="M27 25L31 39L24 35" fill="#78350f" />
    <circle cx="22" cy="18" r="14" fill="#f59e0b" stroke="#d97706" strokeWidth="2" />
    <circle cx="22" cy="18" r="11" fill="#fbbf24" />
    {/* Star inside medal */}
    <path
      d="M22 11.5L23.8 15.2L28 15.8L25 18.7L25.7 22.8L22 20.8L18.3 22.8L19 18.7L16 15.8L20.2 15.2L22 11.5Z"
      fill="#ffffff"
    />
  </svg>
);

const AchievedCheckIcon = () => (
  <svg
    className={styles.achievedCheckIcon}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="7" fill="#15803d" />
    <path
      d="M5 8.2L7 10.2L11 5.8"
      stroke="#ffffff"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CalendarIcon = () => (
  <svg
    className={styles.filterCalendarIcon}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2.5" y="3.5" width="11" height="10" rx="2" stroke="#64748b" strokeWidth="1.3" />
    <path d="M5 2V4.5" stroke="#64748b" strokeWidth="1.3" strokeLinecap="round" />
    <path d="M11 2V4.5" stroke="#64748b" strokeWidth="1.3" strokeLinecap="round" />
    <path d="M2.5 6.5H13.5" stroke="#64748b" strokeWidth="1.3" />
  </svg>
);

const ChevronDownIcon = () => (
  <svg
    className={styles.filterChevron}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 6L8 10L12 6"
      stroke="#64748b"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MetricBlueDocIcon = () => (
  <svg
    className={styles.metricIcon}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4.5" y="3" width="15" height="18" rx="2.5" fill="#3b82f6" />
    <path d="M8 8H16" stroke="#ffffff" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M8 12H16" stroke="#ffffff" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M8 16H13" stroke="#ffffff" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

const MetricGreenCheckIcon = () => (
  <svg
    className={styles.metricIcon}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10" fill="#22c55e" />
    <path
      d="M8 12.2L10.7 15L16 9"
      stroke="#ffffff"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MetricYellowTrophyIcon = () => (
  <svg
    className={styles.metricIcon}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 6C5 9.5 7.5 12 11 12.45V15H9C8.45 15 8 15.45 8 16C8 16.55 8.45 17 9 17H15C15.55 17 16 16.55 16 16C16 15.45 15.55 15 15 15H13V12.45C16.5 12 19 9.5 19 6V4H5V6Z"
      fill="#eab308"
    />
    <path d="M5 6H3C3 8.2 4.8 10 7 10V8C5.9 8 5 7.1 5 6Z" fill="#ca8a04" />
    <path d="M19 6H21C21 8.2 19.2 10 17 10V8C18.1 8 19 7.1 19 6Z" fill="#ca8a04" />
  </svg>
);

const MetricRedXIcon = () => (
  <svg
    className={styles.metricIcon}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10" fill="#ef4444" />
    <path
      d="M8.5 8.5L15.5 15.5M15.5 8.5L8.5 15.5"
      stroke="#ffffff"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
  </svg>
);

export const SettingsHistoricalAchievementsPage: React.FC = () => {
  const vm = useSettingsHistoricalAchievementsViewModel();
  const {
    milestones,
    loading,
    error,
    totalProtests,
    completedProtests,
    wonProtests,
    lostProtests,
    displaySavings,
  } = vm;

  const [timeFilter, setTimeFilter] = useState("All Time");

  return (
    <div className={styles.page}>
      {/* HERO BANNER */}
      <section className={styles.heroBanner}>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>
            <span>Your Tax Protest</span>
            <span className={styles.heroTitleGreen}>Achievements</span>
          </h1>
          <p className={styles.heroSubtitle}>
            Track your tax protest history and see how much you have saved over time.
          </p>
        </div>
        <div className={styles.heroImageWrap}>
          <img
            src={heroBannerImg}
            alt="Andy holding trophy with house background"
            className={styles.heroBannerImg}
          />
        </div>
      </section>

      {loading && <section className={styles.infoCard}>Loading achievements...</section>}
      {!loading && error && <section className={styles.infoCard}>{error}</section>}

      {!loading && !error && (
        <>
          {/* SUMMARY CARDS (2 COLUMNS) */}
          <section className={styles.summaryGrid}>
            <article className={styles.summaryCard}>
              <div className={`${styles.summaryIconWrap} ${styles.summaryIconGreen}`}>
                <MoneyBagIcon />
              </div>
              <div className={styles.summaryInfo}>
                <span className={styles.summaryLabel}>Your Total Tax Savings</span>
                <strong className={`${styles.summaryValue} ${styles.savingsValue}`}>
                  {displaySavings}
                </strong>
                <p className={styles.summaryHelper}>Start a protest to see your savings grow!</p>
              </div>
            </article>

            <article className={styles.summaryCard}>
              <div className={`${styles.summaryIconWrap} ${styles.summaryIconBlue}`}>
                <DocumentSummaryIcon />
              </div>
              <div className={styles.summaryInfo}>
                <span className={styles.summaryLabel}>Status</span>
                <strong className={`${styles.summaryValue} ${styles.statusValue}`}>
                  {totalProtests} active protests
                </strong>
                <p className={styles.summaryHelper}>Keep track of all your ongoing tax protests.</p>
              </div>
            </article>
          </section>

          {/* ACHIEVEMENTS EARNED SECTION */}
          <section className={styles.sectionCard}>
            <h2 className={styles.sectionTitle}>Achievements Earned</h2>
            <div className={styles.milestoneList}>
              {milestones.length === 0 && (
                <div className={styles.emptyMilestones}>No achievements yet.</div>
              )}
              {milestones.map((milestone) => (
                <article className={styles.milestoneCard} key={milestone.id}>
                  <div className={styles.milestoneLeft}>
                    <div className={styles.medalIconWrap}>
                      <MedalIcon />
                    </div>
                    <div className={styles.milestoneInfo}>
                      <h3 className={styles.milestoneTitle}>{milestone.title}</h3>
                      <p className={styles.milestoneDesc}>{milestone.description}</p>
                    </div>
                  </div>
                  <div className={styles.achievedBadge}>
                    <AchievedCheckIcon />
                    <span>Achieved</span>
                  </div>
                </article>
              ))}
            </div>
          </section>

          {/* PERFORMANCE OVERVIEW SECTION */}
          <section className={styles.sectionCard}>
            <div className={styles.sectionHeaderRow}>
              <h2 className={styles.sectionTitle}>Performance Overview</h2>
              <button
                type="button"
                className={styles.filterButton}
                aria-label="Filter performance overview timeframe"
                onClick={() => {
                  setTimeFilter((prev) => (prev === "All Time" ? "This Year" : "All Time"));
                }}
              >
                <CalendarIcon />
                <span>{timeFilter}</span>
                <ChevronDownIcon />
              </button>
            </div>

            <div className={styles.metricsGrid}>
              {/* Total Protests */}
              <article className={`${styles.metricCard} ${styles.metricBlue}`}>
                <div className={`${styles.metricIconWrap} ${styles.metricIconWrapBlue}`}>
                  <MetricBlueDocIcon />
                </div>
                <div className={styles.metricInfo}>
                  <strong className={styles.metricValue}>{totalProtests}</strong>
                  <span className={styles.metricLabel}>Total Protests</span>
                </div>
              </article>

              {/* Completed */}
              <article className={`${styles.metricCard} ${styles.metricGreen}`}>
                <div className={`${styles.metricIconWrap} ${styles.metricIconWrapGreen}`}>
                  <MetricGreenCheckIcon />
                </div>
                <div className={styles.metricInfo}>
                  <strong className={styles.metricValue}>{completedProtests}</strong>
                  <span className={styles.metricLabel}>Completed</span>
                </div>
              </article>

              {/* Won */}
              <article className={`${styles.metricCard} ${styles.metricYellow}`}>
                <div className={`${styles.metricIconWrap} ${styles.metricIconWrapYellow}`}>
                  <MetricYellowTrophyIcon />
                </div>
                <div className={styles.metricInfo}>
                  <strong className={styles.metricValue}>{wonProtests}</strong>
                  <span className={styles.metricLabel}>Won</span>
                </div>
              </article>

              {/* Lost */}
              <article className={`${styles.metricCard} ${styles.metricRed}`}>
                <div className={`${styles.metricIconWrap} ${styles.metricIconWrapRed}`}>
                  <MetricRedXIcon />
                </div>
                <div className={styles.metricInfo}>
                  <strong className={styles.metricValue}>{lostProtests}</strong>
                  <span className={styles.metricLabel}>Lost</span>
                </div>
              </article>
            </div>
          </section>
        </>
      )}
    </div>
  );
};
